import FeaturedTopic from './FeaturedTopic'
import { h, ComponentChild } from 'preact'
import Search from '../algolia/components/Search'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import globals from '../../utils/globals'
import { Hit } from '../algolia/components'

interface FeaturedTopicType {
  id: number
  title: string
  url: string
  contentType: string
}

interface Result {
  oldIndex: number
  newIndex: number
}

interface Props {
  searchPlaceholder: string
  onUpdate: (key: string, value: FeaturedTopicType[]) => void
  featuredTopics: FeaturedTopicType[]
  includeContentTypes?: string[]
  title?: string
  description?: string
  isSortable?: boolean
}

const SortableList = SortableContainer(({ children }: { children: ComponentChild }) => (
  <ul className='sortable-featured-topics-list sortable-curated-topics-list'>{children}</ul>
))
const SortableItem = SortableElement(({ children }: { children: ComponentChild }) => (
  <li className='sortable-featured-topic sortable-curated-topic'>{children}</li>
))
const convertFoundTopicToFeaturedTopic = (foundTopic: Hit): FeaturedTopicType => ({
  id: foundTopic.content_type.includes('idea') ? foundTopic.id : foundTopic.private_id ?? foundTopic.id,
  title: foundTopic.title,
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  url: `${globals('communityUrl')}${foundTopic.topic_url}`,
  contentType: foundTopic.content_type === 'ideation' ? 'idea' : foundTopic.content_type
})

const FeaturedTopicsManager = ({ onUpdate, featuredTopics, searchPlaceholder, includeContentTypes, title, description, isSortable }: Props) => (
  <div class='featured-topics-manager content-curation-manager'>
    {title && <label>{title}</label>}
    {description && <div className='featured-topics-manager-description'>{description}</div>}
    <SortableList
      useDragHandle
      onSortEnd={({ oldIndex, newIndex }: Result) => onUpdate('featuredTopics',
        arrayMove(featuredTopics, oldIndex, newIndex))}
    >
      {featuredTopics.map(
        (featuredTopic, idx) => <SortableItem
          index={idx}
          key={featuredTopic.id}>
          <FeaturedTopic
            title={featuredTopic.title}
            url={featuredTopic.url}
            onDelete={() => onUpdate('featuredTopics',
              featuredTopics.filter(t => t !== featuredTopic))}
            isSortable={isSortable}
          />
        </SortableItem>)}
      <Search
        isControl
        searchPlaceholder={searchPlaceholder}
        callback={foundTopic => onUpdate('featuredTopics', featuredTopics.concat([convertFoundTopicToFeaturedTopic(foundTopic)]))}
        exclude={featuredTopics.map((t: FeaturedTopicType) => t.id)}
        submitIconType='add'
        searchByContentType={includeContentTypes}
      />
    </SortableList>
  </div>
)

export default FeaturedTopicsManager
